/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { LoginDto } from '../models/LoginDto';
import type { LoginResponseDto } from '../models/LoginResponseDto';
import type { UserDto } from '../models/UserDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class AuthenticationService {
    constructor(public readonly http: HttpClient) {}
    /**
     * User login
     * Authenticate user with email and password. The LocalAuthGuard validates credentials and attaches the user to the request.
     * @param requestBody User login credentials (email and password)
     * @returns LoginResponseDto Login successful
     * @throws ApiError
     */
    public authControllerLogin(
        requestBody: LoginDto,
    ): Observable<LoginResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/auth/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid credentials`,
            },
        });
    }
    /**
     * User logout
     * @returns any Logout successful
     * @throws ApiError
     */
    public authControllerLogout(): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/auth/logout',
        });
    }
    /**
     * Get current user profile
     * @returns UserDto User profile retrieved successfully
     * @throws ApiError
     */
    public authControllerGetProfile(): Observable<UserDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/auth/profile',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Refresh access token
     * @returns LoginResponseDto Token refreshed successfully
     * @throws ApiError
     */
    public authControllerRefreshToken(): Observable<LoginResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/auth/refresh',
        });
    }
}
